import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    background-color: white;
  }

  body {
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Montserrat', Helvetica, Arial, sans-serif;
  }

  body::-webkit-scrollbar {
    width: 10px;
    cursor: pointer;
    background-color: #f6f3f3;
  }

  body::-webkit-scrollbar-thumb {
    background-color: #b8b7b7;
    width: 8px;
    border-radius: 4px;
  }

  #app {
    background-color: white;
    min-width: 100%;
    height: 100%;
  }

  p,
  label {
    font-family: Montserrat, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  /* Brand rule (Andy, 2026-10-30): section-sized gradients carry grain, under the content.
     Same tile as wordpress-snapshots/design_css.py (GRAIN_URL); keep the two in step. */
  .grain {
    position: relative;
    isolation: isolate;
  }

  .grain::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    border-radius: inherit;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.95' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix values='1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 0 1'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E") 0 0 / 160px;
    opacity: 0.15;
    mix-blend-mode: overlay;
  }
`;

export default GlobalStyle;
